module.exports = __webpack_public_path__ + "img/balloon_half.2066bf33.svg";